export class EntAnimalRegisterFilter {
  page: number;
  size: number;
  deleted: boolean;
  year?: number;
  regionId?: number;
  areaId?: number;
  farmCategoryIds?: number;
  animalTypeIds?: number;

  constructor(init?: Partial<EntAnimalRegisterFilter>) {
	this.page = 1;
	this.size = 30;
	this.deleted = false;
	if (init) {
	  Object.assign(this, init)
	}
  }
}
